export const authActionType = {
    LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    CLINIC_ID: "CLINIC_ID",
    PATIENT_DETALIS: "PATIENT_DETALIS",
    SIDEBAR_DETAILS: "SIDEBAR_DETAILS",
    ADD_PATIENT_ID: "ADD_PATIENT_ID" 
};